import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"

interface QuestionnaireExtractionErrorCardProps {
  message: string
}

export const QuestionnaireExtractionErrorCard: React.FC<
  QuestionnaireExtractionErrorCardProps
> = ({ message }) => {
  const { translate } = useTranslation()

  return (
    <div className="flex h-full min-h-[60vh] items-center justify-center px-L">
      <Card className="w-full max-w-5xl bg-card">
        <CardHeader className="pb-2 text-center">
          <CardTitle className="text-2xl font-semibold tracking-tight text-card-foreground">
            {translate("QUESTIONNAIRE_QUESTIONS/STATUS_ERROR/TITLE")}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <CardDescription className="text-l mx-auto max-w-3xl text-center leading-relaxed text-muted-foreground">
            {message}
          </CardDescription>
        </CardContent>
      </Card>
    </div>
  )
}
